<ng-container *ngIf="drawerData">
  <div
    [@slideInOut]="{ value: animationState, params: drawerData | drawerDataToAnimationParams }"
    [ngClass]="drawerData | drawerDataToClassList"
    (@slideInOut.done)="onAnimationDone($event)"
    class="drawer-wrapper"
  >
    <ng-container *ngIf="drawerData?.title">
      <div class="drawer-title">
        <ng-container *loopStringTemplateOutlet="drawerData.title">{{ drawerData.title }}</ng-container>
      </div>
    </ng-container>

    <div class="drawer-content">
      <ng-container *ngIf="drawerData && drawerData.content?.component">
        <ng-container
          loopComponentRenderer
          [component]="drawerData.content.component"
          [module]="drawerData.content.module"
          [componentParams]="drawerData.content.componentParams"
          [componentInjector]="drawerData.injector"
        ></ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>
